import { ChannelManager } from 'app/typings/channelManagers';

export type ChannelManagerConfig = {
  name: string;
  iconPath: string;
  classPrefix: string;
};

export const CHANNEL_MANAGER_CONFIG: Record<string, ChannelManagerConfig> = {
  [ChannelManager.SITEMINDER]: {
    name: 'Siteminder',
    iconPath: 'static/icons/siteminder_inventory.jpg',
    classPrefix: 'siteminder',
  },
  [ChannelManager.D_EDGE]: {
    name: 'D-Edge',
    iconPath: 'static/icons/dedge_inventory.png',
    classPrefix: 'dedge',
  },
  [ChannelManager.RESERVIT]: {
    name: 'Reservit',
    iconPath: 'static/icons/reservit_inventory.png',
    classPrefix: 'reservit',
  },
  // Cubilis was replaced by Lighthouse
  // Note: Existing hotels with CUBILIS key will use .variant-CUBILIS class
  // Consider data migration or CSS fallback for legacy support
  [ChannelManager.CUBILIS]: {
    name: 'Lighthouse',
    iconPath: 'static/icons/lighthouse_inventory.png',
    classPrefix: 'cubilis',
  },
  [ChannelManager.TRAVELCLICK]: {
    name: 'Travelclick',
    iconPath: 'static/icons/travelclick_inventory.png',
    classPrefix: 'travelclick',
  },
  [ChannelManager.ROOMCLOUD]: {
    name: 'Roomcloud',
    iconPath: 'static/icons/roomcloud_inventory.png',
    classPrefix: 'roomcloud',
  },
  [ChannelManager.MEWS]: {
    name: 'Mews',
    iconPath: 'static/icons/mews_inventory.png',
    classPrefix: 'mews',
  },
  [ChannelManager.MISTER_BOOKING]: {
    name: 'Mister Booking',
    iconPath: 'static/icons/mister_booking_inventory.png',
    classPrefix: 'mister-booking',
  },
  [ChannelManager.THAIS]: {
    name: 'Thaïs',
    iconPath: 'static/icons/thais_inventory.png',
    classPrefix: 'thais',
  },
};

export const getChannelManagerConfig = (
  channelManager?: string
): ChannelManagerConfig | undefined => {
  if (!channelManager) {
    return undefined;
  }

  return CHANNEL_MANAGER_CONFIG[channelManager];
};
